// Testimonial Slider
const testimonialSlider = document.getElementById("testimonial-slider");

if (testimonialSlider) {
  function sliderInit() {
    const sliderControls = testimonialSlider.querySelector(".slider-controls");

    function asignKeycolor() {
      const activeSlide = testimonialSlider.querySelector(".slide.active");
      const keycolor = activeSlide.style.getPropertyValue("--keyColor");
      testimonialSlider.style.setProperty("--keyColor", keycolor);
    }
    asignKeycolor();

    // go to the slide specified in the URL hash
    const hash = window.location.hash;
    if (hash) {
      const slideNumber = hash.split("-")[2];
      const slideIndex = slideNumber - 1;
      const slides = Array.from(document.querySelectorAll("#testimonial-slider .slide"));
      const slide = slides[slideIndex];
      if (slide) {
        const currentSlide = testimonialSlider.querySelector(".slide.active");
        currentSlide.classList.remove("active");
        slide.classList.add("active");
        asignKeycolor();
      }
    }

    if (sliderControls) {
      const prevControl = sliderControls.querySelector(".prev");
      const nextControl = sliderControls.querySelector(".next");

      // Get all slides
      const slides = Array.from(document.querySelectorAll("#testimonial-slider .slide"));

      let currentSlideIdx = slides.findIndex((slide) => slide.classList.contains("active"));

      function goToSlide(index) {
        if (index === currentSlideIdx) return;

        const currentSlide = slides[currentSlideIdx];
        const nextSlide = slides[index];

        currentSlide.classList.remove("active");
        nextSlide.classList.add("active");

        currentSlideIdx = index;

        // Update URL hash for accessibility
        window.location.hash = `testimonial-slider-${currentSlideIdx + 1}`;

        // Update controls' href and tabindex
        prevControl.setAttribute(
          "href",
          `#testimonial-slider-${currentSlideIdx === 0 ? slides.length : currentSlideIdx}`
        );
        prevControl.setAttribute("tabindex", currentSlideIdx === 0 ? "-1" : "0");
        nextControl.setAttribute(
          "href",
          `#testimonial-slider-${currentSlideIdx + 2 > slides.length ? 1 : currentSlideIdx + 2}`
        );
        nextControl.setAttribute("tabindex", currentSlideIdx + 1 === slides.length ? "-1" : "0");

        asignKeycolor();
      }

      // Add click event listeners using GSAP animations
      prevControl.addEventListener("click", (e) => {
        e.preventDefault();
        goToSlide((currentSlideIdx - 1 + slides.length) % slides.length);
      });

      nextControl.addEventListener("click", (e) => {
        e.preventDefault();
        goToSlide((currentSlideIdx + 1) % slides.length);
      });
    }
  }

  sliderInit();
}
